import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: bookings.Reservation.
export default class Reservation extends Fragment {
  declare [Type]: 'bookings/reservation';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // personId is the id of the person the reservation relates to.
  @attr('string', { defaultValue: '' })
  declare personId: string;
}
